import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import secureStorage from "../../../../../services/secureStorage";
import {
  percentage,
  Rupee,
} from "../../../../../utility/constants/assetsManager";
import {
  colorBlack,
  colorDarkBlue,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { SS_AUTH_TOKEN } from "../../../../../utility/constants/secureStorageManager";
import {
  RUPEES_SYMBOL,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { formDataPush } from "./ResellerDetails";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
        checked={defaultChecked}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

const RollingReserve = ({ reduxData, onSuccess, onClickBack }) => {
  const [changediv, setChangediv] = useState(false);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentValue, setCurrentValue] = useState("ROLLING");
  const { enqueueSnackbar } = useSnackbar();
  const [serviceData, setServiceData] = useState([]);
  const clientData = useSelector((state) => state.onboardClientSlice);

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    border: "0px",
    marginBottom: 20,
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  const containerStyle2 = {
    alignSelf: "center",
    height: 40,
    width: "50%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 2,
    boxSizing: "border-box",
    marginBottom: 20,
    minWidth: "150px",
    maxWidth: "180px",
    border: "1px solid #CBCBCB",
  };

  const style1 = {
    color: "#000000",
    "::placeholder": {
      color: "red",
      opacity: 1,
    },
  };

  const onClickAddClient = (data) => {
    setLoading(true);

    const formdata = formDataPush({ ...clientData, ...data });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "client/create", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
        isimageurl: true,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", margin: "20px 0 15px -10px" }}>
        <RadioButton
          onClick={() => setCurrentValue("rolling")}
          titleStyle={{
            fontSize: "14px",
            // color: " #000E49",
            fontWeight: "400",
            color: currentValue === "ROLLING" ? "#989CFF" : "#000E49",
          }}
          name="Rolling_Reserve"
          title="Rolling Reserve"
          value="ROLLING"
          onChange={(val) => {
            setCurrentValue(val.target.value);
          }}
          defaultChecked={currentValue === "ROLLING"}
        />

        <RadioButton
          onClick={() => setCurrentValue("DEPOSIT")}
          titleStyle={{
            fontSize: "14px",
            // color: " #000E49",
            fontWeight: "400",
            color: currentValue === "DEPOSIT" ? "#989CFF" : "#000E49",
          }}
          name="Security Deposit"
          title="Security Deposit"
          value="DEPOSIT"
          onChange={(val) => {
            setCurrentValue(val.target.value);
          }}
          defaultChecked={currentValue === "DEPOSIT"}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 10,
        }}
      >
        <div
          style={{
            height: "50px",
            width: "50px",
            backgroundColor: "#F3F3F3",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p>{currentValue === "DEPOSIT" ? "₹" : "%"}</p>
        </div>
        <CustomInput
          validator={"paise"}
          onChange={(e) => setValue(e)}
          value={value}
          type={"input"}
          placeholder={currentValue === "DEPOSIT" ? "Enter Amount" : "10"}
          inputStyles={{
            ...inputStyle,
          }}
        />
      </div>
      {currentValue === "ROLLING" && (
        <p
          style={{
            color: "#8590BE",
            fontWeight: "500",
            fontSize: "14px",
            margibnTop: "20px",
          }}
        >
          The limit for the first 40 days of transactions will be 45 lakhs.
        </p>
      )}

      <p
        style={{
          color: "#6C6B6B",
          fontSize: "14px",
          fontWeight: "500",
          margin: "20px 0 20px 0",
        }}
      >
        Set Transaction Volume Limit
      </p>

      <p
        style={{
          color: "#000000",
          fontSize: "12px",
          fontWeight: "500",
          margin: "20px 0 0px 0",
        }}
      >
        Min Transaction Volume
      </p>
      <div style={{ margin: "5px 0 20px 0", background: "#FFFFFF" }}>
        <CustomInput
          inputStyles={{
            ...containerStyle2,
          }}
          type="input"
          placeholder="Enter Min Volume"
        />
      </div>

      <p
        style={{
          color: "#000000",
          fontSize: "12px",
          fontWeight: "500",
          margin: "20px 0 0px 0",
        }}
      >
        Max Transaction Volume
      </p>
      <div style={{ margin: "5px 0 20px 0" }}>
        <CustomInput
          inputStyles={{
            ...containerStyle2,
          }}
          type="input"
          placeholder="Enter Max Volume"
        />
      </div>

      <p
        style={{
          color: "#6C6B6B",
          fontSize: "14px",
          fontWeight: "500",
          margin: "20px 0 20px 0",
        }}
      >
        Set Transaction Value Limit
      </p>

      <p
        style={{
          color: "#000000",
          fontSize: "12px",
          fontWeight: "500",
          margin: "20px 0 0px 0",
        }}
      >
        Min Transaction Value
      </p>
      <div style={{ margin: "5px 0 20px 0" }}>
        <CustomInput
          inputStyles={{
            ...containerStyle2,
          }}
          type="input"
          placeholder="Enter Min Value"
        />
      </div>

      <p
        style={{
          color: "#000000",
          fontSize: "12px",
          fontWeight: "500",
          margin: "20px 0 0px 0",
        }}
      >
        Max Transaction Value
      </p>
      <div style={{ margin: "5px 0 20px 0" }}>
        <CustomInput
          inputStyles={{
            ...containerStyle2,
          }}
          type="input"
          placeholder="Enter Max value"
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: 20,
          justifyContent: "center",
          marginTop: 30,
          marginBottom: 20,
        }}
      >
        <CustomButton
          loading={loading}
          title="Cancel"
          styles={{
            backgroundColor: colorWhite,
            border: "1px solid black",
            padding: 0,
            height: "auto",
            padding: "13px 10px",
          }}
          textStyles={{
            color: colorBlack,
          }}
          onClick={() => onClickBack()}
        />{" "}
        <CustomButton
          title="Save"
          styles={{
            backgroundColor: colorDarkBlue,
            border: "none",
            padding: 0,
            height: "auto",
            padding: "15px 40px",
          }}
          textStyles={{
            color: colorWhite,
          }}
          onClick={() => {
            let rollbackReserves = {};
            let security = {};

            if (currentValue === "ROLLING") {
              rollbackReserves = {
                status: true,
                percentage: value,
              };
            } else {
              rollbackReserves = {
                status: false,
                percentage: 0,
              };
            }
            if (currentValue === "DEPOSIT") {
              security = {
                status: true,
                amount: value * 100,
              };
            } else {
              security = {
                status: false,
                amount: 0,
              };
            }

            onClickAddClient({
              rollbackReserves: JSON.stringify(rollbackReserves),
              security: JSON.stringify(security),
            });
          }}
        />
      </div>
    </div>
  );
};

export default RollingReserve;
